import { render } from "./AsNotice.vue?vue&type=template&id=5e31dbfd&ts=true"
import script from "./AsNotice.vue?vue&type=script&lang=ts"
export * from "./AsNotice.vue?vue&type=script&lang=ts"

import "./AsNotice.vue?vue&type=style&index=0&id=5e31dbfd&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__